/*
 * Recomendados y vistos en la ficha (sections/enova-pdp-tabs.liquid).
 * Pide las tarjetas de las dos pestañas a la misma sección: las recomendaciones de Shopify y los
 * vistos que el tema guarda en el navegador (theme-global.js), menos el producto actual. Con las
 * tarjetas ya puestas monta el carrusel del home (enova-product-tabs), que así mide y anima la
 * entrada con el contenido final. La pestaña sin tarjetas se quita; sin ninguna, la sección no se ve.
 */
if (!customElements.get('enova-pdp-tabs')) {
  const RECENT_KEY = 'minimog-recently-viewed';
  const KEYS = ['recommendations', 'recently'];

  class EnovaPdpTabs extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.limit = parseInt(this.dataset.limit, 10) || 12;

      const recent = this.recentIds();
      Promise.all([
        this.fetchItems(this.dataset.recommendationsUrl, 'recommendations'),
        recent.length
          ? this.fetchItems(this.dataset.searchUrl + encodeURIComponent(recent.map((id) => `id:${id}`).join(' OR ')), 'recently')
          : Promise.resolve([]),
      ]).then(([recommendations, recently]) => this.mount({ recommendations, recently }));
    }

    recentIds() {
      let ids = [];
      try {
        ids = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      } catch (error) {
        ids = [];
      }
      const current = parseInt(this.dataset.productId, 10);
      return (Array.isArray(ids) ? ids : []).filter((id) => Number.isInteger(id) && id !== current).slice(0, this.limit);
    }

    fetchItems(url, key) {
      return fetch(url)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((html) => Array.from(new DOMParser().parseFromString(html, 'text/html')
          .querySelectorAll(`[data-enova-pdp-items="${key}"] > .enova-tabs__item`)).slice(0, this.limit))
        .catch(() => []);
    }

    mount(items) {
      const template = this.querySelector('template');
      const shown = KEYS.filter((key) => items[key].length);
      if (!template || !shown.length) {
        this.closest('.enova-pdp-tabs')?.setAttribute('hidden', '');
        return;
      }

      const fragment = template.content.cloneNode(true);
      KEYS.forEach((key) => {
        const parts = fragment.querySelectorAll(`[data-enova-pdp-key="${key}"]`);
        if (!items[key].length) {
          parts.forEach((node) => node.remove());
          return;
        }
        fragment.querySelector(`[data-enova-tab-panel][data-enova-pdp-key="${key}"] [data-enova-tabs-row]`)
          .append(...items[key].map((item) => document.importNode(item, true)));
      });

      // Una sola pestaña: sin separador y abierta (si quedó solo «vistos», pasa a ser la primera)
      if (shown.length === 1) {
        fragment.querySelectorAll('.enova-tabs__sep').forEach((node) => node.remove());
        const tab = fragment.querySelector('[data-enova-tab]');
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        fragment.querySelector('[data-enova-tab-panel]').hidden = false;
        fragment.querySelector('[data-enova-tab-link]').hidden = false;
      }

      template.replaceWith(fragment);
      window.MinimogTheme?.Wishlist?.setWishlistButtonsState?.();
      window.MinimogTheme?.CompareProduct?.setCompareButtonsState?.();
    }
  }

  customElements.define('enova-pdp-tabs', EnovaPdpTabs);
}
